module.exports = __webpack_public_path__ + "static/media/parceiro_enea.20d122f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parceiro_enea.svg
// module id = 160
// module chunks = 0